module.exports = __webpack_public_path__ + "img/ch16_24_安全部问话.b9d945c1.jpg";